import { DocumentRevisionStatus } from '@/shared/lib';
import type { RecordItem, RecordRevision } from './types';

const AUDIT_USERS = [
  { id: 1, name: 'Ana Souza' },
  { id: 2, name: 'Bruno Lima' },
  { id: 3, name: 'Carla Dias' },
];

const [ANA_SOUZA, BRUNO_LIMA, CARLA_DIAS] = AUDIT_USERS;

const BASE_RECORDS: RecordItem[] = [
  {
    id: 1,
    code: 'RQ01',
    title: 'Registro de Não Conformidades',
    indexing: '000001',
    indexingVersions: ['000001'],
    isActive: true,
    generatedRecordsCount: 15,
    latestRevision: {
      id: 101,
      revision: 3,
      homologationDate: '2026-04-10',
      status: DocumentRevisionStatus.CURRENT,
    },
    olderRevisions: [
      {
        id: 100,
        revision: 2,
        homologationDate: '2025-11-02',
        status: DocumentRevisionStatus.OBSOLETE,
      },
      {
        id: 99,
        revision: 1,
        homologationDate: '2025-05-14',
        status: DocumentRevisionStatus.OBSOLETE,
      },
    ],
    audit: {
      createdAt: '2025-05-14T12:00:00.000Z',
      createdBy: ANA_SOUZA,
      updatedAt: '2026-04-10T12:00:00.000Z',
      updatedBy: BRUNO_LIMA,
    },
  },
  {
    id: 2,
    code: 'RQ02',
    title: 'Registro de Auditoria Interna',
    indexing: '000002',
    indexingVersions: ['000002'],
    isActive: true,
    generatedRecordsCount: 4,
    latestRevision: {
      id: 201,
      revision: 1,
      homologationDate: '2026-01-20',
      status: DocumentRevisionStatus.CURRENT,
    },
    olderRevisions: [],
    audit: {
      createdAt: '2026-01-20T12:00:00.000Z',
      createdBy: ANA_SOUZA,
      updatedAt: null,
      updatedBy: null,
    },
  },
  {
    id: 3,
    code: 'RQ03',
    title: 'Registro de Treinamento de Colaboradores',
    indexing: '000003',
    indexingVersions: ['000003'],
    isActive: true,
    generatedRecordsCount: 28,
    latestRevision: {
      id: 301,
      revision: 2,
      homologationDate: '2025-09-05',
      status: DocumentRevisionStatus.CURRENT,
    },
    olderRevisions: [
      {
        id: 300,
        revision: 1,
        homologationDate: '2025-02-18',
        status: DocumentRevisionStatus.OBSOLETE,
      },
    ],
    audit: {
      createdAt: '2025-02-18T12:00:00.000Z',
      createdBy: CARLA_DIAS,
      updatedAt: '2025-09-05T12:00:00.000Z',
      updatedBy: CARLA_DIAS,
    },
  },
  {
    id: 4,
    code: 'RQ04',
    title: 'Registro de Manutenção de Equipamentos',
    indexing: '000004',
    indexingVersions: ['000004'],
    isActive: true,
    generatedRecordsCount: 7,
    latestRevision: {
      id: 401,
      revision: 1,
      homologationDate: '2026-03-01',
      status: DocumentRevisionStatus.CURRENT,
    },
    olderRevisions: [],
    audit: {
      createdAt: '2026-03-01T12:00:00.000Z',
      createdBy: BRUNO_LIMA,
      updatedAt: null,
      updatedBy: null,
    },
  },
  {
    id: 5,
    code: 'RQ05',
    title: 'Registro de Avaliação de Fornecedores',
    indexing: '000005',
    indexingVersions: ['000005'],
    isActive: true,
    generatedRecordsCount: 52,
    latestRevision: {
      id: 501,
      revision: 4,
      homologationDate: '2025-12-22',
      status: DocumentRevisionStatus.CURRENT,
    },
    olderRevisions: [
      {
        id: 500,
        revision: 3,
        homologationDate: '2025-08-11',
        status: DocumentRevisionStatus.OBSOLETE,
      },
      {
        id: 499,
        revision: 2,
        homologationDate: '2025-04-30',
        status: DocumentRevisionStatus.OBSOLETE,
      },
      {
        id: 498,
        revision: 1,
        homologationDate: '2024-12-01',
        status: DocumentRevisionStatus.OBSOLETE,
      },
    ],
    audit: {
      createdAt: '2024-12-01T12:00:00.000Z',
      createdBy: CARLA_DIAS,
      updatedAt: '2025-12-22T12:00:00.000Z',
      updatedBy: ANA_SOUZA,
    },
  },
  {
    id: 6,
    code: 'RQ09',
    title: 'Registro de Reclamação de Clientes',
    indexing: '000006',
    indexingVersions: ['000006'],
    isActive: true,
    generatedRecordsCount: 11,
    latestRevision: {
      id: 601,
      revision: 2,
      homologationDate: '2026-02-14',
      status: DocumentRevisionStatus.CURRENT,
    },
    olderRevisions: [
      {
        id: 600,
        revision: 1,
        homologationDate: '2025-07-19',
        status: DocumentRevisionStatus.OBSOLETE,
      },
    ],
    audit: {
      createdAt: '2025-07-19T12:00:00.000Z',
      createdBy: BRUNO_LIMA,
      updatedAt: '2026-02-14T12:00:00.000Z',
      updatedBy: BRUNO_LIMA,
    },
  },
];

const EXTRA_RECORD_SUBJECTS = [
  'Calibração de Instrumentos',
  'Inspeção de Recebimento',
  'Devolução de Produtos',
  'Qualificação de Fornecedores',
  'Baixa de Ativos Imobilizados',
  'Higienização de Áreas Limpas',
  'Ordem de Serviço de Manutenção',
  'Empréstimo de Ferramentas',
  'Análise Crítica pela Direção',
  'Zeragem de Balanças',
  'Validação de Processo Produtivo',
  'Descarte de Resíduos Sólidos',
  'Controle de Pragas',
  'Ficha de Emergência Química',
  'Uso de Equipamento de Proteção',
  'Acidentes de Trabalho',
  'Brigada de Incêndio',
  'Exames Ocupacionais',
  'Entrevista de Desligamento',
  'Integração de Novos Colaboradores',
  'Jornada de Trabalho Extraordinária',
  'Avaliação de Desempenho',
  'Levantamento de Necessidades de Treinamento',
  'Matriz de Competências',
  'Solicitação de Compra',
  'Cotação de Materiais',
  'Recebimento Fiscal de Notas',
  'Inventário Rotativo de Estoque',
  'Movimentação Interna de Materiais',
  'Expedição de Produtos Acabados',
  'Rastreabilidade de Lotes',
  'Identificação de Situação do Produto',
  'Liberação de Produto Acabado',
  'Ensaio de Estabilidade',
  'Amostragem de Matéria-Prima',
  'Desvio de Processo',
  'Controle de Mudanças de Projeto',
  'Revisão de Especificação Técnica',
  'Protótipo e Prova de Conceito',
  'Transferência de Tecnologia',
  'Queixa Técnica de Produto',
  'Eventos Adversos de Tecnovigilância',
  'Recall de Produtos no Mercado',
  'Notificação a Órgão Regulatório',
  'Registro de Produto na Anvisa',
  'Petição de Alteração de Registro',
  'Visita Técnica ao Cliente',
  'Pesquisa de Satisfação do Cliente',
  'Ocorrência no Serviço de Atendimento',
  'Proposta Comercial Aprovada',
  'Contrato de Prestação de Serviço',
  'Ordem de Assistência Técnica',
  'Garantia de Produto Reparado',
  'Backup de Bases de Dados',
  'Concessão de Acesso a Sistemas',
  'Incidente de Segurança da Informação',
  'Teste de Restauração de Backup',
  'Mapeamento de Riscos Operacionais',
  'Plano de Ação de Riscos',
  'Indicadores Mensais de Qualidade',
  'Xerocópia de Documento Obsoleto',
];

function buildExtraRecord(subject: string, index: number): RecordItem {
  const sequence = index + 10;
  const id = sequence;
  const revisionId = sequence * 100 + 1;
  const olderRevisionCount = index % 3;
  const homologationDate = new Date(Date.UTC(2024, 0, 5 + index * 5)).toISOString().slice(0, 10);

  const olderRevisions: RecordRevision[] = Array.from(
    { length: olderRevisionCount },
    (_unused, olderIndex) => ({
      id: revisionId - olderIndex - 1,
      revision: olderRevisionCount - olderIndex,
      homologationDate: new Date(Date.UTC(2022, 0, 5 + index * 5 + olderIndex))
        .toISOString()
        .slice(0, 10),
      status: DocumentRevisionStatus.OBSOLETE,
    })
  );

  return {
    id,
    code: `RQ${sequence}`,
    title: `Registro de ${subject}`,
    indexing: String(id).padStart(6, '0'),
    indexingVersions: [String(id).padStart(6, '0')],
    isActive: true,
    generatedRecordsCount: index % 17,
    latestRevision: {
      id: revisionId,
      revision: olderRevisionCount + 1,
      homologationDate,
      status: DocumentRevisionStatus.CURRENT,
    },
    olderRevisions,
    audit: {
      createdAt: `${homologationDate}T12:00:00.000Z`,
      createdBy: AUDIT_USERS[index % AUDIT_USERS.length],
      updatedAt: olderRevisionCount === 0 ? null : `${homologationDate}T18:00:00.000Z`,
      updatedBy: olderRevisionCount === 0 ? null : AUDIT_USERS[(index + 1) % AUDIT_USERS.length],
    },
  };
}

/**
 * Mocked matrices (registros tipo RQ) — the backend does not generate records yet,
 * so this data stands in for the real API until the integration story lands.
 * Every entry represents an active matrix with at least one homologated revision.
 */
export const RECORDS_MOCK: RecordItem[] = [
  ...BASE_RECORDS,
  ...EXTRA_RECORD_SUBJECTS.map(buildExtraRecord),
];
